module.exports = __webpack_public_path__ + "img/SAP_8671_l.e77c38ec.jpg";